const assert = require('assert');
const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class StripeProxyConnector {
  constructor(configuration, tokenManager) {
    assert(configuration, 'configuration is required');
    this.httpClient = axios.create(configuration);

    this.tokenManager = tokenManager;
  }

  async reinstateChargeTransfer({ instanceId, chargeId }) {
    try {
      const options = await this.getOptions();
      const request = {
        url: `/${CURRENT_VERSION}/charges/${instanceId}/${chargeId}/reinstate`,
        method: 'POST',
        ...options,
      };
      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getChargeTransfer({ instanceId, chargeId }) {
    try {
      const options = await this.getOptions();
      const request = {
        url: `/${CURRENT_VERSION}/charges/${instanceId}/${chargeId}/transfer`,
        method: 'GET',
        ...options,
      };
      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async debit({ instanceId, metadata = {}, ...params }) {
    try {
      const options = await this.getOptions();
      const request = {
        url: `/${CURRENT_VERSION}/debits/${instanceId}`,
        method: 'POST',
        data: { metadata, ...params },
        ...options,
      };
      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async transfer({ instanceId, metadata = {}, ...params }) {
    try {
      const options = await this.getOptions();
      const request = {
        url: `/${CURRENT_VERSION}/transfers/${instanceId}`,
        method: 'POST',
        data: { metadata, ...params },
        ...options,
      };
      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async reverseChargeTransfer({ instanceId, chargeId }) {
    try {
      const options = await this.getOptions();
      const request = {
        url: `/${CURRENT_VERSION}/charges/${instanceId}/${chargeId}/reversal`,
        method: 'POST',
        ...options,
      };
      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getChargeById({ instanceId, chargeId }) {
    try {
      const options = await this.getOptions();
      const request = {
        url: `/${CURRENT_VERSION}/charges/${instanceId}/${chargeId}`,
        method: 'GET',
        ...options,
      };
      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getDisputeById({ instanceId, disputeId }) {
    try {
      const options = await this.getOptions();
      const request = {
        url: `/${CURRENT_VERSION}/disputes/${instanceId}/${disputeId}`,
        method: 'GET',
        ...options,
      };
      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getPaymentIntentById({ instanceId, paymentIntentId }) {
    try {
      const options = await this.getOptions();
      const request = {
        url: `/${CURRENT_VERSION}/payment-intents/${instanceId}/${paymentIntentId}`,
        method: 'GET',
        ...options,
      };
      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async cancelPaymentIntent({ instanceId, paymentIntentId }) {
    try {
      const options = await this.getOptions();
      const request = {
        url: `/${CURRENT_VERSION}/payment-intents/${instanceId}/${paymentIntentId}`,
        method: 'DELETE',
        ...options,
      };
      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async triggerReconciliationReport({ instanceId, startDate, endDate }) {
    try {
      const options = await this.getOptions();
      const request = {
        url: `/${CURRENT_VERSION}/reports/reconciliation`,
        method: 'POST',
        data: { instanceId, startDate, endDate },
        ...options,
      };
      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getBankAccountById({ instanceId, accountId, bankAccountId }) {
    try {
      const options = await this.getOptions();
      const request = {
        url: `/${CURRENT_VERSION}/accounts/${instanceId}/${accountId}/bank-accounts/${bankAccountId}`,
        method: 'GET',
        ...options,
      };
      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getOptions() {
    if (!this.tokenManager) {
      return {};
    }

    const token = await this.tokenManager.getToken();
    return {
      headers: {
        Authorization: `Bearer ${token.accessToken}`,
      },
    };
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  StripeProxyConnector,
};
